export default __webpack_public_path__ + "e7c2036ac3cdcabb2ef68fd7fbbea82b.png";